import { modifier } from 'ember-modifier';
import { later } from '@ember/runloop';

export default modifier(
  function containerMonitor(element, params, { containerElementId, layoutMode }) {
    let containerElement = containerElementId
        ? document.getElementById(containerElementId)
        : element;

    if (this.element != element || this.containerElement != containerElement || this.layoutMode != layoutMode) {
      this.element = element;
      this.layoutMode = layoutMode
      this.containerElement = containerElement;
      this.originalThemeColor =  document.querySelector('meta[name="theme-color"]')?.content;
      this.originalViewport = document.querySelector('meta[name="viewport"]')?.content;
    } else {
      return;
    }

    var setVariables = () => {
      setThemeVariables();
      setDimensionVariables();
      setViewportMetaTags();
    }

    var setDimensionVariables = () => {
      later(() => {
        // Layout size, not drawn size, so a zoomed or scaled container doesn't shrink the player twice.
        let containerHeight, containerWidth;
        if (this.layoutMode === 'window') {
          containerHeight = '100dvh';
          containerWidth = '100dvw'
        } else {
          containerHeight = `${this.containerElement.offsetHeight}px`
          containerWidth  = `${this.containerElement.offsetWidth}px`
        }

        let elementHeight = `${element.offsetHeight}px`;
        // console.log('containerHeight:', containerHeight, this.containerElement);
        // console.log('elementHeight:', elementHeight, this.element);
        this.element.style.setProperty('--current-element-height', elementHeight);
        this.element.style.setProperty('--current-container-height', containerHeight);
        this.element.style.setProperty('--current-container-width', containerWidth);

      }, 150);
    }

    var setThemeVariables = () => {
      if (this.layoutMode === 'window') {
        let themeChromeColor = window.getComputedStyle(this.element).getPropertyValue('--system-color-chrome');
        let metaTag = document.querySelector('meta[name="theme-color"]');
        if (metaTag && themeChromeColor) {
          metaTag.content = themeChromeColor;
        }
        document.body.classList.add('dubbletrack-window-layout');
      } else {
        let metaTag = document.querySelector('meta[name="theme-color"]');
        if (metaTag) {
          metaTag.content = this.originalThemeColor;
        }
        document.body.classList.remove('dubbletrack-window-layout');
      }
    }

    var setViewportMetaTags = () => {
      if (this.layoutMode === 'window') {
        let metaTag = document.querySelector('meta[name="viewport"]');
        if (metaTag) {
          metaTag.content = "width=device-width, initial-scale=1.0, viewport-fit=cover";
        }
      } else {
        let metaTag = document.querySelector('meta[name="viewport"]');
        if (metaTag) {
          metaTag.content = this.originalViewport;
        }
      }
    }

    const mutationObserver = new MutationObserver(setVariables);
    const resizeObserver = new ResizeObserver(setVariables);

    mutationObserver.observe(this.containerElement, {
      attributes: true,
      childList: true,
      subtree: false,
    });

    resizeObserver.observe(this.containerElement)
    document.addEventListener('scroll', setVariables);
    setVariables();

    return () => {
      document.removeEventListener('scroll', setVariables);
      mutationObserver.disconnect();
    };
  },
  { eager: false },
);
